/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import { Button, Grid, Group, Input, Modal, Paper, Space, Text, Textarea, ThemeIcon } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconClearAll, IconDeviceFloppy, IconNotes, IconScale, IconZoomMoney } from '@tabler/icons-react';
import { Tabs } from 'antd';
import { useEffect, useMemo, useRef } from 'react';
import BasicPriceTax, { BasicPriceTaxRef } from '../../../../components/BasicPriceTax';
import BasicPricing, { BasicPricingData, BasicPricingRef } from '../../../../components/BasicPricing';
import BasicValueUnits, {
  BasicValueUnitsData,
  BasicValueUnitsRef,
} from '../../../../components/BasicValueUnits';
import EntityItemPicker from '../../../../components/core/EntityItemPicker/EntityItemPicker';
import PageSection from '../../../../components/core/PageSection/PageSection';
import PageViewProperty from '../../../../components/core/PageViewProperty/PageViewProperty';
import ToleranceForm from '../../../../components/core/Tolerance/ToleranceForm';
import { EntityTypeType, UnitOfMeasureType } from '../../../../models/core/cache.type';
import { Action } from '../../../../models/core/core.type';
import { EntitySearchResponseType } from '../../../../models/core/entities.type';
import {
  ProposalResiduePlanPricingType,
  ProposalServiceQuotationType,
  ProposalServiceType,
  ProposalTipoPrecificacaoEnum,
} from '../../../../models/core/proposals.type';
import { EntityItemEnum, Feature, Financial } from '../../../../utils/constants.utils';
import { buildFakeAuditObject, isNullOrEmpty, newGuid } from '../../../../utils/helper.utils';

type FormViewData = {
  action: Action;
  id: string;
  fornecedorData: EntitySearchResponseType | null;
  idFornecedor: number | null;
  fornecedor: string;
  frequencia: number | null;
  frequenciaIdUnidadeMedida1: string | null;
  frequenciaIdUnidadeMedida2: string | null;
  quantidade: number | null;
  preco: number | null;
  precificacao: BasicPricingData;
  primario: boolean;
  observacao: string | null;
  frequenciaFornecedor: unknown;
};

type Props = {
  opened: boolean;
  onClose: () => void;
  modoEdicao: boolean;
  referenceData: {
    entityTypeData?: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
  };
  serviceData: ProposalServiceType;
  origItem: ProposalServiceQuotationType | null;
  item: ProposalServiceQuotationType | null;
  defaultActiveKey?: string;
  zIndex: number;
  callback?: (item: ProposalServiceQuotationType | null, action: string, confirmed: boolean) => void;
};

const buildFornecedorDataFromItem = (
  item: ProposalServiceQuotationType | null
): EntitySearchResponseType | null => {
  if (!item || !item.idFornecedor) return null;
  return {
    ...buildFakeAuditObject(),
    idEntidade: Number(item.idFornecedor),
    idEntidadeServico: item.idEntidadeServico,
    idEntidadeResiduoAcondicionamento: item.idEntidadeResiduoAcondicionamento,
    idEntidadeResiduoEquipamento: item.idEntidadeResiduoEquipamento,
    tipos: [],
    cnpj: item.fornecedorCNPJ || null,
    razaoSocial: item.fornecedorRazaoSocial || null,
    nomeFantasia: item.fornecedorNomeFantasia || null,
    incricaoEstadual: null,
    incricaoMunicipal: null,
    cpf: item.fornecedorCPF || null,
    nome: item.fornecedorNome || null,
    webSite: null,
    aceitaEncontroContas: false,
  };
};

const buildInitialCustomerPricing = (
  item: ProposalServiceQuotationType | null,
  serviceData: ProposalServiceType,
  unitOfMeasures: UnitOfMeasureType[]
): BasicPricingData => ({
  tipoPrecificacao: ProposalTipoPrecificacaoEnum.Especifica,
  quantidade:
    item?.precificacao?.quantidade ??
    serviceData.precificacao?.quantidade ??
    item?.quantidade ??
    serviceData.quantidade ??
    1,
  quantidadeIdUnidadeMedida:
    item?.precificacao?.quantidadeIdUnidadeMedida?.toString() ||
    serviceData.precificacao?.quantidadeIdUnidadeMedida?.toString() ||
    unitOfMeasures
      .find((x) => x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')
      ?.idUnidadeMedida.toString() ||
    null,
  frequenciaIdUnidadeMedida:
    item?.precificacao?.frequenciaIdUnidadeMedida?.toString() ||
    serviceData.precificacao?.frequenciaIdUnidadeMedida?.toString() ||
    null,
  preco: item?.precificacao?.preco ?? serviceData.precificacao?.preco ?? 0,
  imposto: item?.precificacao?.imposto ?? serviceData.precificacao?.imposto ?? Financial.Tax,
});

const buildInitialValues = (
  item: ProposalServiceQuotationType | null,
  origItem: ProposalServiceQuotationType | null,
  serviceData: ProposalServiceType,
  unitOfMeasures: UnitOfMeasureType[]
): FormViewData => {
  const defaultUnit1 =
    serviceData.frequenciaIdUnidadeMedida1?.toString() ||
    unitOfMeasures
      .find((x) => x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')
      ?.idUnidadeMedida.toString() ||
    null;

  return {
    action: origItem ? Action.Nothing : Action.Add,
    id: item?.id || item?.idTemporaria || item?.idPropostaServicoCotacao?.toString() || newGuid(),
    fornecedorData: buildFornecedorDataFromItem(item),
    idFornecedor: item?.idFornecedor || null,
    fornecedor: item?.fornecedorNomeFantasia || item?.fornecedorRazaoSocial || item?.fornecedorNome || '',
    quantidade: item ? item.quantidade ?? null : serviceData.quantidade ?? null,
    frequencia: item ? item.frequencia ?? null : serviceData.frequencia ?? null,
    frequenciaIdUnidadeMedida1: item
      ? item.frequenciaIdUnidadeMedida1?.toString() || defaultUnit1
      : defaultUnit1,
    frequenciaIdUnidadeMedida2: item
      ? item.frequenciaIdUnidadeMedida2?.toString() || null
      : serviceData.frequenciaIdUnidadeMedida2?.toString() || null,
    preco: item?.preco ?? null,
    precificacao: buildInitialCustomerPricing(item, serviceData, unitOfMeasures),
    primario: item?.primario || false,
    observacao: item?.observacao || '',
    frequenciaFornecedor: null,
  };
};

export default function ServiceQuotationModal(props: Props) {
  const refToleranceForm = useRef<any>();
  const refSupplierFrequency = useRef<BasicValueUnitsRef>(null);
  const refSupplierPriceTax = useRef<BasicPriceTaxRef>(null);
  const refCustomerPricing = useRef<BasicPricingRef>(null);
  const isHydratingRef = useRef(false);
  const hydrationTimeoutRef = useRef<number | null>(null);

  const pricingType =
    props.item?.precificacao?.tipo ||
    props.origItem?.precificacao?.tipo ||
    props.serviceData.precificacao?.tipo ||
    ProposalTipoPrecificacaoEnum.Especifica;

  const isGeneralPricing = pricingType === ProposalTipoPrecificacaoEnum.Geral;

  const serviceItemType = props.serviceData.idResiduoAcondicionamento
    ? EntityItemEnum.Packaging
    : props.serviceData.idResiduoEquipamento
    ? EntityItemEnum.Equipment
    : EntityItemEnum.Service;

  const buildFrequencyFromContext = useMemo(() => {
    const um1 =
      props.referenceData.unitOfMeasures.find(
        (x) => x.idUnidadeMedida === props.serviceData.frequenciaIdUnidadeMedida1
      )?.unidadeMedida || 'un';

    const um2 =
      props.referenceData.unitOfMeasures.find(
        (x) => x.idUnidadeMedida === props.serviceData.frequenciaIdUnidadeMedida2
      )?.unidadeMedida || '';

    return `${
      serviceItemType === EntityItemEnum.Service ? `${props.serviceData.quantidade} ` : ''
    }${um1} / ${um2}`;
  }, [props.referenceData.unitOfMeasures, props.serviceData, serviceItemType]);

  // const frequencyUnit1Options = useMemo(
  //   () =>
  //     props.referenceData.unitOfMeasures
  //       .filter(
  //         (x) =>
  //           (serviceItemType === EntityItemEnum.Service &&
  //             ((x.tipo === 'Tempo' && x.unidadeMedidaSigla === 'h') ||
  //               (x.tipo === 'Outro' && x.unidadeMedidaSigla !== 'per'))) ||
  //           (x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')
  //       )
  //       .map((x) => ({
  //         value: x.idUnidadeMedida.toString(),
  //         label: `${x.unidadeMedida} (${x.unidadeMedidaSigla})`,
  //         group: x.tipo,
  //       })),
  //   [props.referenceData.unitOfMeasures, serviceItemType]
  // );

  const frequencyUnit2Options = useMemo(
    () =>
      props.referenceData.unitOfMeasures
        .filter(
          (x) =>
            (x.tipo === 'Tempo' &&
              (x.unidadeMedidaSigla === 'd' ||
                x.unidadeMedidaSigla === 'sem' ||
                x.unidadeMedidaSigla === 'mês' ||
                x.unidadeMedidaSigla === 'ano')) ||
            (x.tipo === 'Outro' && x.unidadeMedidaSigla === 'per')
        )
        .map((x) => ({
          value: x.idUnidadeMedida.toString(),
          label: `${x.unidadeMedida} (${x.unidadeMedidaSigla})`,
          group: x.tipo,
        })),
    [props.referenceData.unitOfMeasures]
  );

  const quantityUnitOptions = useMemo(
    () =>
      props.referenceData.unitOfMeasures
        .filter((x) => x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')
        .map((x) => ({
          value: x.idUnidadeMedida.toString(),
          label: `${x.unidadeMedida} (${x.unidadeMedidaSigla})`,
          group: x.tipo,
        })),
    [props.referenceData.unitOfMeasures]
  );

  const buildPricingTypeFromQuotation = (pricingData: BasicPricingData): ProposalResiduePlanPricingType => {
    const quantidadeIdUnidadeMedida = pricingData.quantidadeIdUnidadeMedida
      ? Number(pricingData.quantidadeIdUnidadeMedida)
      : null;
    const frequenciaIdUnidadeMedida = pricingData.frequenciaIdUnidadeMedida
      ? Number(pricingData.frequenciaIdUnidadeMedida)
      : null;

    return {
      tipo: ProposalTipoPrecificacaoEnum.Especifica,
      quantidade: pricingData.quantidade,
      quantidadeIdUnidadeMedida,
      quantidadeUnidadeMedida:
        props.referenceData.unitOfMeasures.find((x) => x.idUnidadeMedida === quantidadeIdUnidadeMedida)
          ?.unidadeMedida || null,
      quantidadeUnidadeMedidaSigla:
        props.referenceData.unitOfMeasures.find((x) => x.idUnidadeMedida === quantidadeIdUnidadeMedida)
          ?.unidadeMedidaSigla || null,
      frequenciaIdUnidadeMedida,
      frequenciaUnidadeMedida:
        props.referenceData.unitOfMeasures.find((x) => x.idUnidadeMedida === frequenciaIdUnidadeMedida)
          ?.unidadeMedida || null,
      frequenciaUnidadeMedidaSigla:
        props.referenceData.unitOfMeasures.find((x) => x.idUnidadeMedida === frequenciaIdUnidadeMedida)
          ?.unidadeMedidaSigla || null,
      preco: pricingData.preco,
      imposto: pricingData.imposto,
    };
  };

  const form = useForm<FormViewData>({
    initialValues: buildInitialValues(
      props.item,
      props.origItem,
      props.serviceData,
      props.referenceData.unitOfMeasures
    ),
  });

  const itemKey =
    props.item?.id || props.item?.idPropostaServicoCotacao?.toString() || props.item?.idTemporaria || 'new';
  const serviceKey =
    props.serviceData?.id ||
    props.serviceData?.idPropostaServico?.toString() ||
    (props.serviceData as any).idTemporaria ||
    props.serviceData?.idServico?.toString() ||
    'service';

  useEffect(() => {
    if (!props.opened) return;

    const nextValues = buildInitialValues(
      props.item,
      props.origItem,
      props.serviceData,
      props.referenceData.unitOfMeasures
    );
    isHydratingRef.current = true;
    if (hydrationTimeoutRef.current) {
      window.clearTimeout(hydrationTimeoutRef.current);
    }

    form.setValues(nextValues);
    form.resetDirty();
    form.clearErrors();
    hydrationTimeoutRef.current = window.setTimeout(() => {
      isHydratingRef.current = false;
      hydrationTimeoutRef.current = null;
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemKey, serviceKey, props.opened]);

  useEffect(() => {
    if (!props.opened) return undefined;

    return () => {
      if (hydrationTimeoutRef.current) {
        window.clearTimeout(hydrationTimeoutRef.current);
        hydrationTimeoutRef.current = null;
      }
      isHydratingRef.current = false;
    };
  }, [props.opened]);

  const isSupplierDefined = !!form.values.idFornecedor;

  const isModified = (
    frequencyData?: BasicValueUnitsData | null,
    supplierPriceTaxData?: { preco: number | null; imposto: number | null } | null,
    customerPricingData?: BasicPricingData | null
  ) => {
    const normalize = (value: unknown) => (isNullOrEmpty(value) ? '' : String(value));

    const origData = `${normalize(props.origItem?.idFornecedor)}|${normalize(
      props.origItem?.quantidade
    )}|${normalize(props.origItem?.frequencia)}|${normalize(
      props.origItem?.frequenciaIdUnidadeMedida1
    )}|${normalize(props.origItem?.frequenciaIdUnidadeMedida2)}|${normalize(
      props.origItem?.preco
    )}|${normalize(props.origItem?.precificacao?.quantidade)}|${normalize(
      props.origItem?.precificacao?.quantidadeIdUnidadeMedida
    )}|${normalize(props.origItem?.precificacao?.frequenciaIdUnidadeMedida)}|${normalize(
      props.origItem?.precificacao?.preco
    )}|${normalize(props.origItem?.precificacao?.imposto)}|${normalize(props.origItem?.primario)}|${normalize(
      props.origItem?.observacao
    )}`;

    const formData = `${normalize(form.values.idFornecedor)}|${normalize(frequencyData?.valor)}|${normalize(
      null
    )}|${normalize(frequencyData?.idUnidade1)}|${normalize(frequencyData?.idUnidade2)}|${normalize(
      supplierPriceTaxData?.preco
    )}|${normalize(customerPricingData?.quantidade)}|${normalize(
      customerPricingData?.quantidadeIdUnidadeMedida
    )}|${normalize(customerPricingData?.frequenciaIdUnidadeMedida)}|${normalize(
      customerPricingData?.preco
    )}|${normalize(customerPricingData?.imposto)}|${normalize(form.values.primario)}|${normalize(
      form.values.observacao
    )}`;

    return origData !== formData;
  };

  const clearFornecedorData = () => {
    form.setFieldValue('fornecedorData', null);
    form.setFieldValue('idFornecedor', undefined as never as null);
    form.setFieldValue('fornecedor', '');
    form.setFieldValue('preco', '' as never as null);
    form.setFieldValue('quantidade', null);
    form.setFieldValue('frequencia', null);
    form.setFieldValue('frequenciaIdUnidadeMedida1', null);
    form.setFieldValue('frequenciaIdUnidadeMedida2', null);
    refSupplierFrequency.current?.clear();
    refSupplierPriceTax.current?.clear();
  };

  const handleSubmit = () => {
    if (!props.modoEdicao) {
      props.onClose();
      return;
    }

    const frequencyData = !isSupplierDefined
      ? { valor: null, idUnidade1: null, idUnidade2: null }
      : refSupplierFrequency.current?.validate();
    const supplierPriceTaxData = !isSupplierDefined
      ? { preco: null, imposto: null }
      : refSupplierPriceTax.current?.validate();
    const inheritedCustomerPricingData = buildInitialCustomerPricing(
      props.item,
      props.serviceData,
      props.referenceData.unitOfMeasures
    );
    const customerPricingData = isGeneralPricing
      ? inheritedCustomerPricingData
      : refCustomerPricing.current?.validate();

    if (form.validate().hasErrors || !frequencyData || !supplierPriceTaxData || !customerPricingData) {
      return;
    }

    if (!isNullOrEmpty(supplierPriceTaxData.preco) && isNullOrEmpty(frequencyData.valor)) {
      form.setFieldError(
        'frequenciaFornecedor',
        <Text size="xs" mt={5}>
          Campo obrigatório quando o preço é informado.
        </Text>
      );
      return;
    }

    frequencyData.valor = isNullOrEmpty(frequencyData.valor) ? null : Number(frequencyData.valor);

    let values = { ...form.values };
    let nextAction = values.action;

    if (props.origItem) {
      if (
        isModified(frequencyData, supplierPriceTaxData, customerPricingData) &&
        props.origItem.idPropostaServicoCotacao
      ) {
        nextAction = Action.Modify;
      } else {
        values = {
          ...props.origItem,
          ...values,
          action: props.item?.action || Action.Nothing,
          quantidade: frequencyData.valor,
          frequenciaIdUnidadeMedida1: frequencyData.idUnidade1 || '',
          frequenciaIdUnidadeMedida2: frequencyData.idUnidade2 || '',
        };
        nextAction = values.action;
      }
    }

    const formItem: ProposalServiceQuotationType = {
      ...buildFakeAuditObject(),
      ...(props.origItem || {}),
      ...values,
      action: nextAction,
      id: values.id,
      idTemporaria: props.origItem?.idTemporaria || values.id,
      idPropostaServicoCotacao: props.origItem?.idPropostaServicoCotacao || 0,
      idPropostaServico: props.serviceData.idPropostaServico || -1,
      preco: supplierPriceTaxData.preco,
      precificacao: buildPricingTypeFromQuotation(customerPricingData),
    };

    formItem.quantidade = frequencyData.valor;
    formItem.frequencia = null;
    formItem.frequenciaIdUnidadeMedida1 = frequencyData.idUnidade1 ? Number(frequencyData.idUnidade1) : null;
    formItem.frequenciaUnidadeMedida1 =
      formItem.frequenciaIdUnidadeMedida1 === null
        ? ''
        : props.referenceData.unitOfMeasures.find(
            (x) => x.idUnidadeMedida === Number(frequencyData.idUnidade1)
          )?.unidadeMedida || '';
    formItem.frequenciaIdUnidadeMedida2 = frequencyData.idUnidade2 ? Number(frequencyData.idUnidade2) : null;
    formItem.frequenciaUnidadeMedida2 =
      formItem.frequenciaIdUnidadeMedida2 === null
        ? ''
        : props.referenceData.unitOfMeasures.find(
            (x) => x.idUnidadeMedida === Number(frequencyData.idUnidade2)
          )?.unidadeMedida || '';

    formItem.preco = formItem.preco === null ? null : Number(formItem.preco);
    formItem.idEntidadeServico = (form.values.fornecedorData as any)?.idEntidadeServico || null;
    formItem.idEntidadeResiduoAcondicionamento =
      (form.values.fornecedorData as any)?.idEntidadeResiduoAcondicionamento || null;
    formItem.idEntidadeResiduoEquipamento =
      (form.values.fornecedorData as any)?.idEntidadeResiduoEquipamento || null;
    formItem.idFornecedor =
      form.values.fornecedorData?.idEntidade || form.values.idFornecedor
        ? Number(form.values.fornecedorData?.idEntidade || form.values.idFornecedor)
        : null;
    formItem.fornecedorCNPJ = form.values.fornecedorData?.cnpj || null;
    formItem.fornecedorRazaoSocial = form.values.fornecedorData?.razaoSocial || null;
    formItem.fornecedorNomeFantasia = form.values.fornecedorData?.nomeFantasia || null;
    formItem.fornecedorCPF = form.values.fornecedorData?.cpf || null;
    formItem.fornecedorNome = form.values.fornecedorData?.nome || null;
    formItem.idServico = props.serviceData.idServico;
    formItem.servico = props.serviceData.servico;
    formItem.servicoDescricao = props.serviceData.servicoDescricao || null;
    formItem.idResiduoAcondicionamento = props.serviceData.idResiduoAcondicionamento || null;
    formItem.residuoAcondicionamento = props.serviceData.residuoAcondicionamento || null;
    formItem.residuoAcondicionamentoDescricao = props.serviceData.residuoAcondicionamentoDescricao || null;
    formItem.idResiduoEquipamento = props.serviceData.idResiduoEquipamento || null;
    formItem.residuoEquipamento = props.serviceData.residuoEquipamento || null;
    formItem.residuoEquipamentoDescricao = props.serviceData.residuoEquipamentoDescricao || null;
    formItem.observacao = formItem.observacao?.trim() || null;
    formItem.tolerancias = refToleranceForm.current?.validate() || props.item?.tolerancias || [];

    if (!isSupplierDefined) {
      formItem.idFornecedor = null;
      formItem.idEntidadeServico = null;
      formItem.idEntidadeResiduoAcondicionamento = null;
      formItem.idEntidadeResiduoEquipamento = null;
      formItem.fornecedorCNPJ = null;
      formItem.fornecedorRazaoSocial = null;
      formItem.fornecedorNomeFantasia = null;
      formItem.fornecedorCPF = null;
      formItem.fornecedorNome = null;
      formItem.quantidade = null;
      formItem.frequencia = null;
      formItem.frequenciaIdUnidadeMedida1 = null;
      formItem.frequenciaIdUnidadeMedida2 = null;
      formItem.frequenciaUnidadeMedida1 = '';
      formItem.frequenciaUnidadeMedida2 = '';
      formItem.preco = null;
    }

    props.callback?.({ ...formItem, action: nextAction, id: values.id }, 'callback', true);
    props.onClose();
  };

  const modalActionLabel = props.item ? (props.modoEdicao ? 'Editar' : 'Visualizar') : 'Adicionar';

  const tabs = [
    {
      key: 'Cotacao',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconZoomMoney size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Cotação
          </Text>
        </Group>
      ),
      children: (
        <>
          {!isGeneralPricing && (
            <>
              <Paper shadow="xs" p="md" withBorder>
                <PageSection
                  size="md"
                  color={Feature.Home.Proposal.color}
                  label="Cliente"
                  text="Informações operacionais da cotação com o cliente."
                />
                <Space h="xs" />
                <BasicPricing
                  ref={refCustomerPricing}
                  isEdit={props.modoEdicao}
                  disabled={!props.modoEdicao}
                  hideTipoPrecificacaoSelector
                  forcePricingActive
                  withFrequency
                  value={{
                    ...form.values.precificacao,
                    tipoPrecificacao: ProposalTipoPrecificacaoEnum.Especifica,
                  }}
                  onChange={(pricingData) => {
                    if (isHydratingRef.current) return;
                    form.setFieldValue('precificacao', pricingData);
                  }}
                  quantityUnitOptions={quantityUnitOptions}
                  frequencyUnitOptions={frequencyUnit2Options}
                  quantityUnitDisabled
                  zIndex={props.zIndex + 1}
                />
              </Paper>
              <Space h="md" />
            </>
          )}

          <Paper shadow="xs" p="md" withBorder>
            <Group justify="space-between">
              <PageSection
                size="md"
                color={Feature.Home.Proposal.color}
                label="Fornecedor"
                text="Informações operacionais da cotação com o fornecedor."
              />
              {isSupplierDefined && (
                <Button
                  leftSection={<IconClearAll size={18} />}
                  size="xs"
                  color="orange"
                  onClick={clearFornecedorData}
                  disabled={!props.modoEdicao}
                >
                  Limpar
                </Button>
              )}
            </Group>
            <Space h="xs" />
            <Grid columns={4}>
              <Grid.Col span={4}>
                <EntityItemPicker
                  label="Fornecedor"
                  item={serviceItemType}
                  itemId={
                    (serviceItemType === EntityItemEnum.Packaging
                      ? props.serviceData.idResiduoAcondicionamento
                      : serviceItemType === EntityItemEnum.Equipment
                      ? props.serviceData.idResiduoEquipamento
                      : props.serviceData.idServico) || -1
                  }
                  formItem={form.getInputProps('idFornecedor') || undefined}
                  idsToBeDisabled={[]}
                  callback={async (item: EntitySearchResponseType | null) => {
                    if (item) {
                      form.setFieldValue('fornecedorData', item);
                      form.setFieldValue('idFornecedor', item.idEntidade);
                      form.setFieldValue(
                        'fornecedor',
                        item.nomeFantasia || item.razaoSocial || item.nome || ''
                      );
                    }
                  }}
                  required={false}
                  disabled={!props.modoEdicao}
                  zIndex={props.zIndex + 1}
                />
              </Grid.Col>

              {isSupplierDefined && (
                <>
                  <Grid.Col span={3}>
                    <Input.Wrapper {...form.getInputProps('frequenciaFornecedor')}>
                      <BasicValueUnits
                        ref={refSupplierFrequency}
                        isEdit={props.modoEdicao}
                        disabled={!props.modoEdicao || !isSupplierDefined}
                        disableUnit1
                        zIndex={props.zIndex + 1}
                        label="Quantidade/Frequência"
                        showValue
                        value={{
                          valor: form.values.quantidade,
                          idUnidade1: form.values.frequenciaIdUnidadeMedida1,
                          idUnidade2: form.values.frequenciaIdUnidadeMedida2,
                        }}
                        onChange={(frequencyData) => {
                          if (isHydratingRef.current) return;
                          form.setFieldValue('quantidade', frequencyData.valor);
                          form.setFieldValue('frequencia', null);
                          form.setFieldValue('frequenciaIdUnidadeMedida1', frequencyData.idUnidade1);
                          form.setFieldValue('frequenciaIdUnidadeMedida2', frequencyData.idUnidade2);
                        }}
                        unit1Options={quantityUnitOptions}
                        unit2Options={frequencyUnit2Options}
                        validationMode="all-or-none"
                        valueMin={serviceItemType === EntityItemEnum.Service ? 0.5 : 1}
                        valueDefaultValue={1}
                        valueStep={serviceItemType === EntityItemEnum.Service ? 0.5 : 1}
                      />
                    </Input.Wrapper>
                  </Grid.Col>
                  <Grid.Col span={1}>
                    <BasicPriceTax
                      ref={refSupplierPriceTax}
                      isEdit={props.modoEdicao}
                      disabled={!props.modoEdicao || !isSupplierDefined}
                      requiredPrice={
                        !isNullOrEmpty(form.values.quantidade) &&
                        !isNullOrEmpty(form.values.frequenciaIdUnidadeMedida2)
                      }
                      showTax={false}
                      labelPreco="Preço"
                      value={{
                        preco: form.values.preco,
                        imposto: null,
                      }}
                      zIndex={props.zIndex + 1}
                    />
                  </Grid.Col>
                </>
              )}

              <Grid.Col span={4}>
                <Textarea
                  leftSection={<IconNotes size={15} />}
                  label="Observação"
                  placeholder="Observação sobre a cotação do serviço"
                  autosize
                  maxLength={500}
                  disabled={!props.modoEdicao}
                  {...form.getInputProps('observacao')}
                />
              </Grid.Col>
            </Grid>
          </Paper>
        </>
      ),
      forceRender: true,
    },
    {
      key: 'Tolerancias',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconScale size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Tolerâncias
          </Text>
        </Group>
      ),
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <ToleranceForm
            ref={refToleranceForm}
            refId={props.item?.idPropostaServicoCotacao}
            title="Tolerâncias"
            description="Tolerâncias para esta cotação."
            color={Feature.Home.Proposal.color}
            disabled={!props.modoEdicao}
            origData={props.origItem?.tolerancias || []}
            data={props.item?.tolerancias || []}
            referenceData={props.referenceData}
            zIndex={props.zIndex + 1}
          />
        </Paper>
      ),
      forceRender: true,
    },
  ];

  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      title={`Cotação de serviço - ${modalActionLabel}`}
      size="75%"
      closeOnClickOutside={false}
      zIndex={props.zIndex}
    >
      <Paper shadow="xs" p="md" withBorder>
        <Paper shadow="xs" p="md" withBorder>
          <PageSection
            size="lg"
            color={Feature.Home.Proposal.color}
            label="Cotação para:"
            text="Este é o serviço a ser cotado e poderá estar acompanhado de um tipo de acondicionamento ou equipamento."
          />
          <Space h="xs" />
          <Grid columns={4}>
            <Grid.Col span={1}>
              <PageViewProperty label="Serviço" text={props.serviceData.servico || '-'} size="sm" />
            </Grid.Col>
            <Grid.Col span={1}>
              <PageViewProperty label="Quantidade" text={props.serviceData.quantidade || '-'} size="sm" />
            </Grid.Col>
            {props.serviceData.idResiduoAcondicionamento ? (
              <Grid.Col span={1}>
                <PageViewProperty
                  label="Acondicionamento"
                  text={props.serviceData.residuoAcondicionamento || '-'}
                  size="sm"
                />
              </Grid.Col>
            ) : props.serviceData.idResiduoEquipamento ? (
              <Grid.Col span={1}>
                <PageViewProperty
                  label="Equipamento"
                  text={props.serviceData.residuoEquipamento || '-'}
                  size="sm"
                />
              </Grid.Col>
            ) : null}
            <Grid.Col span={1}>
              <PageViewProperty label="Frequência" text={buildFrequencyFromContext} size="sm" />
            </Grid.Col>
          </Grid>
        </Paper>
        <Space h="lg" />
        <Paper shadow="xs" p="md" withBorder>
          <Tabs items={tabs} defaultActiveKey={props.defaultActiveKey || 'Cotacao'} />
        </Paper>
      </Paper>
      <Space h="xl" />
      <Group justify="right">
        {props.modoEdicao ? (
          <Button leftSection={<IconDeviceFloppy size={18} />} onClick={handleSubmit}>
            Salvar
          </Button>
        ) : (
          <Button onClick={props.onClose}>Fechar</Button>
        )}
      </Group>
    </Modal>
  );
}
